export default __webpack_public_path__ + "static/green-dots-blob-2-6813edfcbb012f050d2236ce191e0c14.svg";